// extracted by mini-css-extract-plugin
export default {"Form":"SendPlainSms_Form__oCxy9","FlexRow":"SendPlainSms_FlexRow__eEWR-"};